var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('input',{staticClass:"search-control",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('i',{staticClass:"search-icon fa-solid fa-magnifying-glass"})])
}
var staticRenderFns = []

export { render, staticRenderFns }